import React from 'react'
import StoresLayout from './StoresLayout'
import {StoresQueryRequestProvider} from './core/StoresRequestProvider'
import {StoresQueryResponseProvider} from './core/StoresResponseProvider'
import { StoresContextProvider } from './core/Stores'

const StoresWrapper = () => {
  return (
    <StoresContextProvider>
      <StoresQueryRequestProvider>
        <StoresQueryResponseProvider>
          <StoresLayout />
        </StoresQueryResponseProvider>
      </StoresQueryRequestProvider>
    </StoresContextProvider>
  )
}

export default StoresWrapper
